module.exports = __webpack_public_path__ + "assets/img/no_member_djs_bg.9c953337.jpg";